import {Component, EventEmitter, Output} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {Store} from "@ngrx/store";
import {cameraActions} from "src/app/state/camera/camera.actions";
import {Vector3} from "three";
import {ActivatedRoute, Router} from "@angular/router";
import {User} from "../../auth/primitives/user";

import * as AuthSelectors from '../../state/auth/auth.selector';
import {FilesService} from "../../services/files/files.service";
import {ProfileImageComponent} from "../profile-image/profile-image.component";
import {DoWhenReadyService, Readyables} from "../../services/do-when-ready.service";
import {SearchService} from "../../services/search.service";

@Component({
  selector: "binsta-header-bar",
  standalone: true,
  imports: [FormsModule, ProfileImageComponent],
  templateUrl: "./header-bar.component.html",
  styleUrl: "./header-bar.component.scss",
})
export class HeaderBarComponent {
  @Output()
  isActive = new EventEmitter();

  oldSearchText = "";
  searchText = "";
  profileActive = false

  user: User = null
  profileBase64: string

  constructor(
      private store: Store,
      private router: Router,
     private route: ActivatedRoute,
      private fileService: FilesService,
      private doWhenReady: DoWhenReadyService,
      private searchService: SearchService
  ) {
    this.doWhenReady.firstTime(this, [Readyables.network], async (user: User)=> {
      this.user = user
      const serverFile = await this.fileService.getFile(this.user.profile_image_file_id)
      this.profileBase64 = serverFile.fileData
    })
  }

  setSearchActive(enabled: boolean) {
    if (enabled) {
      this.searchText = this.oldSearchText;
      this.router.navigate([{outlets: {'right-pane': "search"}}])
    }
    if (!enabled) {
      this.searchText = "";
      this.oldSearchText = this.searchText;
      this.router.navigate([{outlets: {'right-pane': null }}]);
    }
  }

  setProfileActive() {
    this.profileActive = !this.profileActive
    if (this.profileActive) {
      this.router.navigate([{outlets: {'right-pane': "profile"}}])
    } else {
      this.router.navigate([{outlets: {'right-pane': null}}])
    }
  }

  async searchKeyPressed(event: string) {
    if (event.length > 0) {
      this.setSearchActive(true)
    } else {
      this.setSearchActive(false)
    }
    this.searchService.searchTerm.next(event)
  }

  enterPressed(input) {
    const text = this.searchText;
    if (this.isCoordinate(text)) return;
  }

  isCoordinate(input) {
    const matches = input.match(/([+-]?\d+)::?([+-]?\d+)(?:::?([+-]?\d+))?/);
    if (matches) {
      const coordx = matches[1];
      const coordy = matches[2];
      const coordz = matches[3];
      this.gotoLocation(coordx, coordy, coordz);
      return true;
    }
    return false;
  }

  gotoLocation(x: string, y: string, z: string) {
    this.store.dispatch(
      cameraActions.targetJumped({
        target: new Vector3(parseInt(x), parseInt(y), parseInt(z)),
      }),
    );
  }
}
